import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './disabled.scss'

const Disabled = (props) => {
  const { disabled, cursor, onClick, children, block } = props

  let onClickProps = {}

  if (onClick && !disabled) {
    onClickProps = {
      onClick,
      onKeyDown: onClick,
      role: 'button',
      tabIndex: '0'
    }
  }

  const disabledClass = classNames({
    [styles.disabled]: disabled,
    [styles.cursor]: disabled && cursor,
    [styles.block]: block
  })

  return (
    <div
      className={disabledClass}
      {...onClickProps} // eslint-disable-line react/jsx-props-no-spreading
    >
      {children}
    </div>
  )
}

Disabled.defaultProps = {
  disabled: false,
  cursor: false,
  onClick: null,
  children: null,
  block: false
}

const { bool, func, element, node, oneOfType, string } = PropTypes

Disabled.propTypes = {
  disabled: bool,
  cursor: bool,
  onClick: func,
  children: oneOfType([element, node, string]),
  block: bool
}

export default Disabled
